import React from 'react';
import {connect} from 'react-redux';
import {Switch, Route, Redirect} from 'react-router-dom';
import AwardList from './AwardList';
import AwardDetail from './AwardDetail';
import ReaderAwardList from './ReaderAwardList';
import ReaderAwardDetail from './ReaderAwardDetail';
import * as permissions from 'utils/permissions';

class Award extends React.Component {
  render() {
    const {role} = this.props;
    return permissions.isReader(role) ? (
      <Switch>
        <Route exact path="/awards" component={ReaderAwardList} />
        <Redirect to="/awards" />
      </Switch>
    ) : (
      <Switch>
        <Route path="/awards/:awardId(\d+)" component={AwardDetail} />
        <Route exact path="/awards" component={AwardList} />
        <Redirect to="/awards" />
      </Switch>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.account.getIn(['user', 'role']),
});

export default connect(mapStateToProps, null)(Award);
